// Per-event automation conditions and actions for the settings UI.
// SYNC: When adding/removing/reordering event condition or action keys in AUTOMATIONS below,
// update config/automation_rules_schema.yml (events.*.conditions / events.*.actions).
// That YAML backs automation.get_automation_schema (MCP) via AutomationRules::SchemaService.
import {
  OPERATOR_TYPES_1,
  OPERATOR_TYPES_2,
  OPERATOR_TYPES_3,
  OPERATOR_TYPES_8,
} from './operators';

export const AUTOMATIONS = {
  message_created: {
    conditions: [
      {
        key: 'message_type',
        name: 'MESSAGE_TYPE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'image_type',
        name: 'MESSAGE_IMAGE_TYPE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'emoji_only',
        name: 'EMOJI_ONLY',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'content',
        name: 'MESSAGE_CONTAINS',
        inputType: 'comma_separated_plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'status',
        name: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'assignee_id',
        name: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'team_id',
        name: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'labels',
        name: 'LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'is_forwarded_email',
        name: 'IS_FORWARDED_EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_8,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'add_label',
        name: 'ADD_LABEL',
      },
      {
        key: 'remove_label',
        name: 'REMOVE_LABEL',
      },
      {
        key: 'add_smart_label',
        name: 'ADD_SMART_LABEL',
      },
      {
        key: 'add_smart_label_prototype',
        name: 'ADD_SMART_LABEL_PROTOTYPE',
      },
      {
        key: 'fill_attributes_with_ai',
        name: 'FILL_ATTRIBUTES_WITH_AI',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'send_email_confirmation',
        name: 'SEND_EMAIL_CONFIRMATION',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'open_conversation',
        name: 'OPEN_CONVERSATION',
      },
      {
        key: 'pending_conversation',
        name: 'PENDING_CONVERSATION',
      },
      {
        key: 'resolve_conversation',
        name: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
    ],
  },
  conversation_created: {
    conditions: [
      {
        key: 'status',
        name: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'browser_language',
        name: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'is_forwarded_email',
        name: 'IS_FORWARDED_EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_8,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_type',
        name: 'CONVERSATION_TYPE',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'labels',
        name: 'LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'image_type',
        name: 'MESSAGE_IMAGE_TYPE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'emoji_only',
        name: 'EMOJI_ONLY',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'add_label',
        name: 'ADD_LABEL',
      },
      {
        key: 'remove_label',
        name: 'REMOVE_LABEL',
      },
      {
        key: 'add_smart_label',
        name: 'ADD_SMART_LABEL',
      },
      {
        key: 'add_smart_label_prototype',
        name: 'ADD_SMART_LABEL_PROTOTYPE',
      },
      {
        key: 'fill_attributes_with_ai',
        name: 'FILL_ATTRIBUTES_WITH_AI',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'send_email_confirmation',
        name: 'SEND_EMAIL_CONFIRMATION',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'pending_conversation',
        name: 'PENDING_CONVERSATION',
      },
      {
        key: 'resolve_conversation',
        name: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
      {
        key: 'add_to_lead_network',
        name: 'ADD_TO_LEAD_NETWORK',
      },
    ],
  },
  conversation_updated: {
    conditions: [
      {
        key: 'status',
        name: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'browser_language',
        name: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'is_forwarded_email',
        name: 'IS_FORWARDED_EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_8,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'assignee_id',
        name: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'team_id',
        name: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_type',
        name: 'CONVERSATION_TYPE',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'labels',
        name: 'LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_3,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'add_label',
        name: 'ADD_LABEL',
      },
      {
        key: 'remove_label',
        name: 'REMOVE_LABEL',
      },
      {
        key: 'add_smart_label',
        name: 'ADD_SMART_LABEL',
      },
      {
        key: 'add_smart_label_prototype',
        name: 'ADD_SMART_LABEL_PROTOTYPE',
      },
      {
        key: 'fill_attributes_with_ai',
        name: 'FILL_ATTRIBUTES_WITH_AI',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'send_email_confirmation',
        name: 'SEND_EMAIL_CONFIRMATION',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'pending_conversation',
        name: 'PENDING_CONVERSATION',
      },
      {
        key: 'resolve_conversation',
        name: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
      {
        key: 'mark_as_pending',
        name: 'MARK_AS_PENDING',
      },
      {
        key: 'odoo_create',
        name: 'ODOO_CREATE',
      },
      {
        key: 'odoo_update',
        name: 'ODOO_UPDATE',
      },
    ],
  },
  conversation_opened: {
    conditions: [
      {
        key: 'browser_language',
        name: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'is_forwarded_email',
        name: 'IS_FORWARDED_EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_8,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'assignee_id',
        name: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'team_id',
        name: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_type',
        name: 'CONVERSATION_TYPE',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'labels',
        name: 'LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_3,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'add_label',
        name: 'ADD_LABEL',
      },
      {
        key: 'remove_label',
        name: 'REMOVE_LABEL',
      },
      {
        key: 'add_smart_label',
        name: 'ADD_SMART_LABEL',
      },
      {
        key: 'add_smart_label_prototype',
        name: 'ADD_SMART_LABEL_PROTOTYPE',
      },
      {
        key: 'fill_attributes_with_ai',
        name: 'FILL_ATTRIBUTES_WITH_AI',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'send_email_confirmation',
        name: 'SEND_EMAIL_CONFIRMATION',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'pending_conversation',
        name: 'PENDING_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
    ],
  },
  conversation_resolved: {
    conditions: [
      {
        key: 'browser_language',
        name: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'is_forwarded_email',
        name: 'IS_FORWARDED_EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_8,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'assignee_id',
        name: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'team_id',
        name: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'add_label',
        name: 'ADD_LABEL',
      },
      {
        key: 'remove_label',
        name: 'REMOVE_LABEL',
      },
      {
        key: 'add_smart_label',
        name: 'ADD_SMART_LABEL',
      },
      {
        key: 'add_smart_label_prototype',
        name: 'ADD_SMART_LABEL_PROTOTYPE',
      },
      {
        key: 'fill_attributes_with_ai',
        name: 'FILL_ATTRIBUTES_WITH_AI',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'send_email_confirmation',
        name: 'SEND_EMAIL_CONFIRMATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
      {
        key: 'odoo_create',
        name: 'ODOO_CREATE',
      },
      {
        key: 'odoo_update',
        name: 'ODOO_UPDATE',
      },
    ],
  },
  planning_event_created: {
    conditions: [
      {
        key: 'name',
        name: 'EVENT_NAME',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'description',
        name: 'DESCRIPTION',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'event_status',
        name: 'STAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'current_total_price',
        name: 'CURRENT_TOTAL_PRICE',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'event_manager_id',
        name: 'EVENT_MANAGER',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'event_manager_team_id',
        name: 'EVENT_MANAGER_TEAM',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'customer_id',
        name: 'CUSTOMER',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'event_label_id',
        name: 'EVENT_LABEL',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'event_border_color',
        name: 'EVENT_BORDER_COLOR',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'event_source',
        name: 'EVENT_SOURCE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'booking_widget_id',
        name: 'BOOKING_WIDGET',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'apply_event_color',
        name: 'SET_EVENT_COLOR',
        inputType: 'color',
      },
      {
        key: 'set_event_label',
        name: 'SET_EVENT_LABEL',
        inputType: 'search_select',
      },
      {
        key: 'lock_event_price',
        name: 'LOCK_EVENT_PRICE',
      },
      {
        key: 'unlock_event_price',
        name: 'UNLOCK_EVENT_PRICE',
      },
      {
        key: 'add_event_collaborators',
        name: 'ADD_EVENT_COLLABORATORS',
        inputType: 'user_team_collaborators',
      },
      {
        key: 'remove_event_collaborators',
        name: 'REMOVE_EVENT_COLLABORATORS',
        inputType: 'user_team_collaborators',
      },
      {
        key: 'send_email_confirmation',
        name: 'SEND_EMAIL_CONFIRMATION',
      },
      {
        key: 'send_event_sheet_email',
        name: 'SEND_EVENT_SHEET_EMAIL',
      },
      {
        key: 'attach_event_documents',
        name: 'ATTACH_EVENT_DOCUMENTS',
      },
      {
        key: 'send_documents_for_signature',
        name: 'SEND_DOCUMENTS_FOR_SIGNATURE',
      },
      {
        key: 'set_event_custom_attributes',
        name: 'SET_EVENT_CUSTOM_ATTRIBUTES',
        inputType: 'event_custom_attribute',
      },
    ],
  },
  planning_event_updated: {
    conditions: [
      {
        key: 'name',
        name: 'EVENT_NAME',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'description',
        name: 'DESCRIPTION',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'event_status',
        name: 'STAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'current_total_price',
        name: 'CURRENT_TOTAL_PRICE',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'event_manager_id',
        name: 'EVENT_MANAGER',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'event_manager_team_id',
        name: 'EVENT_MANAGER_TEAM',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'customer_id',
        name: 'CUSTOMER',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'event_label_id',
        name: 'EVENT_LABEL',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'event_border_color',
        name: 'EVENT_BORDER_COLOR',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'event_source',
        name: 'EVENT_SOURCE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'booking_widget_id',
        name: 'BOOKING_WIDGET',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'apply_event_color',
        name: 'SET_EVENT_COLOR',
        inputType: 'color',
      },
      {
        key: 'clear_event_color',
        name: 'CLEAR_EVENT_COLOR',
      },
      {
        key: 'set_event_label',
        name: 'SET_EVENT_LABEL',
        inputType: 'search_select',
      },
      {
        key: 'clear_event_label',
        name: 'CLEAR_EVENT_LABEL',
      },
      {
        key: 'lock_event_price',
        name: 'LOCK_EVENT_PRICE',
      },
      {
        key: 'unlock_event_price',
        name: 'UNLOCK_EVENT_PRICE',
      },
      {
        key: 'add_event_collaborators',
        name: 'ADD_EVENT_COLLABORATORS',
        inputType: 'user_team_collaborators',
      },
      {
        key: 'remove_event_collaborators',
        name: 'REMOVE_EVENT_COLLABORATORS',
        inputType: 'user_team_collaborators',
      },
      {
        key: 'send_email_confirmation',
        name: 'SEND_EMAIL_CONFIRMATION',
      },
      {
        key: 'send_event_sheet_email',
        name: 'SEND_EVENT_SHEET_EMAIL',
      },
      {
        key: 'attach_event_documents',
        name: 'ATTACH_EVENT_DOCUMENTS',
      },
      {
        key: 'send_documents_for_signature',
        name: 'SEND_DOCUMENTS_FOR_SIGNATURE',
      },
      {
        key: 'set_event_custom_attributes',
        name: 'SET_EVENT_CUSTOM_ATTRIBUTES',
        inputType: 'event_custom_attribute',
      },
    ],
  },
};

export const AUTOMATION_RULE_EVENTS = [
  {
    key: 'conversation_created',
    value: 'CONVERSATION_CREATED',
  },
  {
    key: 'conversation_updated',
    value: 'CONVERSATION_UPDATED',
  },
  {
    key: 'conversation_resolved',
    value: 'CONVERSATION_RESOLVED',
  },
  {
    key: 'message_created',
    value: 'MESSAGE_CREATED',
  },
  {
    key: 'conversation_opened',
    value: 'CONVERSATION_OPENED',
  },
  {
    key: 'planning_event_created',
    value: 'PLANNING_EVENT_CREATED',
  },
  {
    key: 'planning_event_updated',
    value: 'PLANNING_EVENT_UPDATED',
  },
];

export const AUTOMATION_ACTION_TYPES = [
  {
    key: 'assign_agent',
    label: 'ASSIGN_AGENT',
    inputType: 'search_select',
  },
  {
    key: 'assign_team',
    label: 'ASSIGN_TEAM',
    inputType: 'search_select',
  },
  {
    key: 'add_label',
    label: 'ADD_LABEL',
    inputType: 'multi_select',
  },
  {
    key: 'remove_label',
    label: 'REMOVE_LABEL',
    inputType: 'multi_select',
  },
  {
    key: 'send_email_to_team',
    label: 'SEND_EMAIL_TO_TEAM',
    inputType: 'team_message',
  },
  {
    key: 'send_email_transcript',
    label: 'SEND_EMAIL_TRANSCRIPT',
    inputType: 'email',
  },
  {
    key: 'send_email_confirmation',
    label: 'SEND_EMAIL_CONFIRMATION',
    inputType: 'email',
  },
  {
    key: 'send_event_sheet_email',
    label: 'SEND_EVENT_SHEET_EMAIL',
    inputType: 'email',
  },
  {
    key: 'attach_event_documents',
    label: 'ATTACH_EVENT_DOCUMENTS',
    inputType: 'plain_text',
  },
  {
    key: 'send_documents_for_signature',
    label: 'SEND_DOCUMENTS_FOR_SIGNATURE',
    inputType: null,
  },
  {
    key: 'mute_conversation',
    label: 'MUTE_CONVERSATION',
    inputType: null,
  },

  {
    key: 'snooze_conversation',
    label: 'SNOOZE_CONVERSATION',
    inputType: null,
  },
  {
    key: 'resolve_conversation',
    label: 'RESOLVE_CONVERSATION',
    inputType: null,
  },
  {
    key: 'open_conversation',
    label: 'OPEN_CONVERSATION',
    inputType: null,
  },
  {
    key: 'pending_conversation',
    label: 'PENDING_CONVERSATION',
    inputType: null,
  },
  {
    key: 'send_webhook_event',
    label: 'SEND_WEBHOOK_EVENT',
    inputType: 'url',
  },
  {
    key: 'send_attachment',
    label: 'SEND_ATTACHMENT',
    inputType: 'attachment',
  },
  {
    key: 'send_message',
    label: 'SEND_MESSAGE',
    inputType: 'textarea',
  },
  {
    key: 'add_private_note',
    label: 'ADD_PRIVATE_NOTE',
    inputType: 'textarea',
  },
  {
    key: 'change_priority',
    label: 'CHANGE_PRIORITY',
    inputType: 'search_select',
  },
  {
    key: 'add_sla',
    label: 'ADD_SLA',
    inputType: 'search_select',
  },
  {
    key: 'odoo_create',
    label: 'ODOO_CREATE',
    inputType: 'odoo_create',
  },
  {
    key: 'odoo_update',
    label: 'ODOO_UPDATE',
    inputType: 'odoo_update',
  },
  {
    key: 'add_smart_label',
    label: 'ADD_SMART_LABEL',
    inputType: 'multi_select',
  },
  {
    key: 'add_smart_label_prototype',
    label: 'ADD_SMART_LABEL_PROTOTYPE',
    inputType: 'multi_select',
  },
  {
    key: 'mark_as_pending',
    label: 'MARK_AS_PENDING',
    inputType: null,
  },
  {
    key: 'fill_attributes_with_ai',
    label: 'FILL_ATTRIBUTES_WITH_AI',
    inputType: 'custom_attributes_multi_select',
  },
  {
    key: 'apply_event_border_color',
    label: 'SET_EVENT_COLOR',
    inputType: 'color',
  },
  {
    key: 'clear_event_border_color',
    label: 'CLEAR_EVENT_COLOR',
    inputType: null,
  },
  {
    key: 'apply_event_color',
    label: 'SET_EVENT_COLOR',
    inputType: 'color',
  },
  {
    key: 'clear_event_color',
    label: 'CLEAR_EVENT_COLOR',
    inputType: null,
  },
  {
    key: 'set_event_label',
    label: 'SET_EVENT_LABEL',
    inputType: 'search_select',
  },
  {
    key: 'clear_event_label',
    label: 'CLEAR_EVENT_LABEL',
    inputType: null,
  },
  {
    key: 'lock_event_price',
    label: 'LOCK_EVENT_PRICE',
    inputType: null,
  },
  {
    key: 'unlock_event_price',
    label: 'UNLOCK_EVENT_PRICE',
    inputType: null,
  },
  {
    key: 'add_event_collaborators',
    label: 'ADD_EVENT_COLLABORATORS',
    inputType: 'user_team_collaborators',
  },
  {
    key: 'remove_event_collaborators',
    label: 'REMOVE_EVENT_COLLABORATORS',
    inputType: 'user_team_collaborators',
  },
  {
    key: 'set_event_custom_attributes',
    label: 'SET_EVENT_CUSTOM_ATTRIBUTES',
    inputType: 'event_custom_attribute',
  },
  {
    key: 'add_to_lead_network',
    label: 'ADD_TO_LEAD_NETWORK',
    inputType: 'plain_text',
  },
];

export const CUSTOM_TEMPLATE_ACTION_PREFIX = 'send_custom_email_template__';

export const buildCustomTemplateActions = customTemplateNames =>
  customTemplateNames.map(name => ({
    key: `${CUSTOM_TEMPLATE_ACTION_PREFIX}${name}`,
    name: name,
  }));

export const buildCustomTemplateActionTypes = customTemplateNames =>
  customTemplateNames.map(name => ({
    key: `${CUSTOM_TEMPLATE_ACTION_PREFIX}${name}`,
    label: name,
    inputType: 'email',
    skipTranslation: true,
  }));
